var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({},'div',_vm.$attrs,false),[_c('div',{staticClass:"overflow-hidden -mb-[0.1em]"},[_c('div',{staticClass:"slide-up-animation",class:{
        'translate-x-full': _vm.horizontal && !_vm.reversed,
        '-translate-x-full': _vm.horizontal && _vm.reversed,
        'translate-y-full': !_vm.horizontal && !_vm.reversed,
        '-translate-y-full': !_vm.horizontal && _vm.reversed,
        'transition-transform transform-none': _vm.inView,
      }},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }